var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThermometerSimple = function SvgIconThermometerSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.056 3.305A2.75 2.75 0 0 1 14.75 5.25v9.263a1 1 0 0 0 .23.639 3.875 3.875 0 1 1-5.96 0 1 1 0 0 0 .23-.64V5.25c0-.73.29-1.429.806-1.945M12 .5a4.75 4.75 0 0 0-4.75 4.75v8.92a5.875 5.875 0 1 0 9.5 0V5.25A4.75 4.75 0 0 0 12 .5m0 7.125a1 1 0 0 1 1 1v7.124a2.125 2.125 0 1 1-2 0V8.625a1 1 0 0 1 1-1m0 9.875a.125.125 0 1 0 0 .25.125.125 0 0 0 0-.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconThermometerSimple;